import { EnvironmentService } from '@core/services/environment.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import type { DocumentType } from '@core/services/daviplata.interface';
import { GetOperationMoviiResponse, MoviiCreateOperationRequest, MoviiCreateOperationResponse, MoviiSessionDetails } from './movii.interface';
import { encodeApiPathSegment } from '@core/utils/api-path.utils';

@Injectable({
  providedIn: 'root'
})
export class MoviiService {
  private get baseUrl(): string {
    return this.environmentService.env.apiConfig.payinCheckoutBackendUrl;
  }

  constructor(private environmentService: EnvironmentService, private http: HttpClient) { }

  findDocumentByCountry(documentType: 'N' | 'J' | string = 'N') {
    return this.http.get<DocumentType[]>(`${this.baseUrl}common/master-parameters/api/find/documentCountry/COL`, {
      params: { documentType },
    });
  }

  createOperation(body: MoviiCreateOperationRequest): Observable<MoviiCreateOperationResponse> {
    return this.http.post<MoviiCreateOperationResponse>(`${this.baseUrl}common/operation/create/movii`, body);
  }

  getPaymentDetails(verification: string): Observable<MoviiSessionDetails> {
    return this.http.get<MoviiSessionDetails>(
      `${this.baseUrl}common/session/find/voucher/movii/${encodeApiPathSegment(verification)}`,
    );
  }

  getOperation(transactionId: string, verification: string): Observable<GetOperationMoviiResponse> {
    const encodedTransactionId = encodeApiPathSegment(transactionId);
    const encodedVerification = encodeURIComponent(verification);

    return this.http.get<GetOperationMoviiResponse>(
      `${this.baseUrl}common/operation/operations/${encodedTransactionId}?verification=${encodedVerification}`,
    );
  }
}
